import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _get from 'lodash/get';
export function getAddressText(address) {
  return address.street_address;
}
export function timeToMinutes(timeString) {
  var normalizedTimeString = timeString || '00:00:00';
  var regExp = new RegExp(/\d{1,2}:\d{1,2}(:\d{1,2})?/);
  var match = normalizedTimeString.match(regExp);
  if (!match) {
    return 0;
  }
  var _normalizedTimeString = normalizedTimeString.split(':'),
    _normalizedTimeString2 = _slicedToArray(_normalizedTimeString, 2),
    hours = _normalizedTimeString2[0],
    minutes = _normalizedTimeString2[1];
  var totalMinutes = Number(hours) * 60 + Number(minutes);
  return totalMinutes;
}
export function shouldShowFulfillmentPickers(order) {
  return _get(order, 'fulfillment_methods', []).length > 1;
}
export function isFulfillmentTypeAvailable(order, fulfillmentType) {
  return _get(order, 'fulfillment_methods', []).filter(function (fulfillmentMethod) {
    return fulfillmentMethod.type === fulfillmentType;
  }).length > 0;
}
export function getOnlyFulfillmentMethodTypeAvailable(order) {
  return _get(order, 'fulfillment_methods[0].type', null);
}